import type { Entry } from "./session.ts";

/**
 * What moves as one when the session is put in another order: a movement,
 * a superset's movements, or the circuit's. Split apart, a superset would no
 * longer be done in turns, and the circuit's rounds would lose their card.
 */
export function blocksOf(entries: Entry[]): Entry[][] {
  const blocks: Entry[][] = [];
  entries.forEach((entry, index) => {
    const before = entries[index - 1];
    const together =
      before !== undefined &&
      ((entry.circuitGroup !== null && entry.circuitGroup === before.circuitGroup) ||
        (entry.supersetGroup !== null && entry.supersetGroup === before.supersetGroup));
    if (together) blocks.at(-1)!.push(entry);
    else blocks.push([entry]);
  });
  return blocks;
}

/** The blocks with the one at `from` put at `to`, the others closing up behind it. */
export function moveBlock<T>(blocks: T[], from: number, to: number): T[] {
  const moved = [...blocks];
  const [block] = moved.splice(from, 1);
  if (block === undefined) return blocks;
  moved.splice(Math.max(0, Math.min(to, moved.length)), 0, block);
  return moved;
}

/** What the server is sent: every line, block after block. */
export function lineIds(blocks: Entry[][]): number[] {
  return blocks.flat().map((entry) => entry.id);
}
